import { render, staticRenderFns } from "./add-contract.vue?vue&type=template&id=5cd68f85&scoped=true"
import script from "./add-contract.vue?vue&type=script&lang=js"
export * from "./add-contract.vue?vue&type=script&lang=js"
import style0 from "./add-contract.vue?vue&type=style&index=0&id=5cd68f85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd68f85",
  null
  
)

export default component.exports